import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader


import { BsInfoCircleFill } from 'react-icons/bs'
import PageHeaderComponent from '../../components/pageHeader'
import './styles.scss'

import irisImage1 from '../../projects/IRIS.png'
import irisReport from '../../projects/irisReport.png'
import amyImage1 from '../../projects/AMY_Donate.png'
import amyImage2 from '../../projects/AMY_Home.png'
import amyImage3 from '../../projects/AMY_Login.png'
import molaImage1 from '../../projects/MOLA_SuperAdm.png'
import molaImage2 from '../../projects/MOLA_Org.png'
import qwellerImage1 from '../../projects/Qweller.png'
import pythonProjectsImage1 from '../../projects/PythonProjects.png'
import aiImage1 from '../../projects/AI.png'
import discordImage1 from '../../projects/Discord.png'
import selfSupperImage1 from '../../projects/SelfSupper.png'
import youtubeAddOnImage1 from '../../projects/Youtube.jpg'
import gestureMap from '../../projects/gestureMap.png'
import gestureHands from '../../projects/gestureHands.png'
import gestureControls from '../../projects/gestureControls.png'


const projectCodes = [
    "iris",
    "amy",
    'gesture',
    'mola',
    'qweller',
    'pythonProjects',
    'ai',
    'discord',
    'selfSupper',
    'youtubeAddOn',
];

const ProjectImagesList = {
    "iris": [irisImage1, irisReport],
    "amy": [amyImage1, amyImage2, amyImage3],
    'gesture': [gestureMap, gestureHands, gestureControls],
    'mola': [molaImage1, molaImage2],
    'qweller': [qwellerImage1],
    'pythonProjects': [pythonProjectsImage1],
    'ai': [aiImage1],
    'discord': [discordImage1],
    'selfSupper': [selfSupperImage1],
    'youtubeAddOn': [youtubeAddOnImage1],
};

const projectNames = {
    "iris": "Project IRIS",
    "amy": "AMY",
    'gesture': 'Gesture Controlled 3D World',
    'mola': "MOLA",
    'qweller': "Qweller",
    'pythonProjects': "Python Projects",
    'ai': "AI Projects",
    'discord': "Motivator Bot",
    'selfSupper': "Self Supper",
    'youtubeAddOn': "Youtube Playlist Time Calculator",
};

const projectNamesPuns = {
    "iris": "An EYE for the Police!",
    "amy": "A Meal by You",
    'gesture': 'The world on your finger tips!',
    'mola': "My Online Local Ambulance",
    'qweller': "Qwik Seller",
    'pythonProjects': "A repository of many utility projects made in Python",
    'ai': "A repository of 5 AI projects made in Python, Prolog and Matlab",
    'discord': "A Discord bot",
    'selfSupper': "An Uncoventional Restaurant",
    'youtubeAddOn': "An innovative Firefox Add-on",
};

const projectDates = {
    "iris": ["March 2022", "August 2022"],
    "amy": ["January 2022", "April 2022"],
    'gesture': ['April 2023', 'April 2023'],
    'mola': ["August 2021", "December 2021"],
    'qweller': ["January 2022", "February 2022"],
    'pythonProjects': ["August 2020", "Ongoing"],
    'ai': ["August 2021", "December 2021"],
    'discord': ["May 2021", "May 2021"],
    'selfSupper': ["March 2021", "December 2021"],
    'youtubeAddOn': ["February 2022", "February 2022"],
};

const projectLinks = {
    "iris": "https://iris-frontend-five.vercel.app/",
    "amy": "https://amy-a-meal-by-me.web.app/",
    'gesture': "https://gesture-controlled-3-d-world.vercel.app/",
    'mola': "https://mola-afb82.firebaseapp.com/",
    'qweller': "https://github.com/ps428/QwikProject/tree/master/qwik-seller",
    'pythonProjects': "https://github.com/ps428/PythonProjects",
    'ai': "https://github.com/ps428/AI-Projects",
    'discord': "https://github.com/ps428/Motivator-Bot",
    'selfSupper': "https://github.com/ps428/Self-Supper",
    'youtubeAddOn':
        "https://addons.mozilla.org/bn/firefox/addon/youtube-playlist-time-calc/",

};

const projectTechStack = {
    "iris":
        "Python (FastAPI), JavaScript (Leaflet API), TailwindCSS, HTML, MongoDB",
    "amy": "Flutter, Firebase",
    'gesture': 'Mediapipe, CesiumJS, JavaScript, HTML, CSS',
    'mola': "JavaScript (Google Maps API), Firebase, CSS, HTML",
    'qweller': "TypeScript, Qwik, TailwindCSS, HTML",
    'pythonProjects': "Python, Selenium, Data Scrapers, Automation",
    'ai': "Python, AI, Prolog, Matlab, Mini-Max Algorithm ",
    'discord': "Python, APIs, Discord ",
    'selfSupper': "NodeJS, APIs, SQL, HTML, CSS",
    'youtubeAddOn': "JavaScript, Add-on",
};

const projectDetails = {
    'iris': [
        "A web map based real-time crime monitoring system for police.\n",
        "The project is compatible with NCRB database for quick integration with real dataset, included CCTV usage, crime heatmaps, and multiple other utilities!\n",
        "This project fetched me a chance to interact with the Prime Minister of India!"
    ],
    'amy': [
        "An innovative food donation app made in Flutter and deployed on Firebase.\n",
        "Aims to solve the issue of lapsing balance in student’s mess account.\n",
        "Well documented project with complete SRS, DFD, structure chart and report."
    ],
    'gesture': [
        "A 3D world controlled by hand gestures.\n",
        "Made using Mediapipe, CesiumJS, JavaScript, HTML, CSS.\n",
        "A fun project that can be extended to multiple domains."
    ],
    'mola': [
        "Made using HTML, CSS & JS with Firebase RTDB database and deployed on Firebase.\n",
        "Inspired by the problems faced during the Covid 19 pandemic.\n",
        "There are three views for the webapp: User, Admin and Super Admin."
    ],
    'qweller': [
        "A demo project made using the latest Qwik Framework.\n",
        "Learnt TypeScript for the very first time for this project.\n",
        "This can act as a base for any other e commerce website."
    ],
    'pythonProjects': [
        "This is the repository of all my cool Python projects.\n",
        "This indeed is my largest amount of work, from August 2020 to present, a lot of my work done in Python is present in this repo.\n",
        "You can just go to the repo and check out whatever you need!"
    ],
    'ai': [
        "There are 5 major projects in this repository. In each respective directory I have added the problem statemtnt in Problem.pdf file.\n",
        "A link with detailed description and explaination of my approach is also present in the Readme.md file.\n",
        "These projects were a part of the course CSD 311 Artificial Intelligence taught by Prof. Saroj Kaushik."
    ],
    'discord': [
        "This is a Discord bot that replies motivational quotes to a user if they use depressing or sad words in the chat.\n",
        "Made with Python, this bot extracts a random quote from https://zenquotes.io.\n",
        "You can try to add this bot to your Discord chat: Motivator#2208 Discord id."
    ],
    'selfSupper': [
        "An application which besides functioning as a conventional restaurant, gives the user the special power to submit his own recipe to be added to the menu and earn rewards upon approval.\n",
        "You can check out this cool readme to understand the project well: https://github.com/ps428/Self-Supper/blob/master/Readme.pdf\n",
        "The application has an admin and a user side view."
    ],
    'youtubeAddOn': [
        "A simple extension to calculate total time of a YouTube playlist!\n",
        "Wish to go through a playlist (or tutorial) and don't want to spend time on counting the total time taken for completing the playlist.\n",
        "Use this cool extension for Firefox to know how much time would be taken to complete any playlist available on YouTube."
    ]
};


const makeProjectCard = (projectCode) => {
    return <div className="flip-box">
        <div className="flip-box-inner">
            <div className="flip-box-front">
                <h2 className='projectTitle'>{projectNames[projectCode]}</h2>
                <h4 className='projectPun'>{projectNamesPuns[projectCode]}</h4>
                <Carousel autoPlay infiniteLoop>
                    {
                        ProjectImagesList[projectCode].map((image, index) => (
                            <div className='projectImage' key={index}>
                                <img src={ProjectImagesList[projectCode][index]}></img>
                            </div>
                        ))
                    }

                </Carousel>
                {/* <a className='button' href={projectLinks[projectCode]} >Project Demo</a> */}
            </div>
            <div className="flip-box-back">
                <h2 className='projectTitle'>{projectNames[projectCode]}</h2>
                <h4 className='projectPun'>{projectNamesPuns[projectCode]}</h4>
                <h3 className='projectDetails'>Project Details</h3>
                <p className='projectDate'><strong>Project duration:</strong> from {projectDates[projectCode][0]} to {projectDates[projectCode][1]}</p>
                <ul>
                    {
                        projectDetails[projectCode].map((detail, index) => (
                            <li className='projectBasicText' key={index}><strong>➳</strong>&nbsp;  {detail}</li>
                        ))

                    }
                </ul>
                <p className='projectTech'><strong>Tech used:</strong> {projectTechStack[projectCode]}</p>
                <a className='button' href={projectLinks[projectCode]} >Project Demo</a>
            </div>
        </div>
    </div>
}

const Projects = () => {
    return (
        <section id="projects" className='projects'>
            <PageHeaderComponent
                headerText="Projects"
                icon={<BsInfoCircleFill size={40} />}
            />
            <p className='tip'> * Please hover over the project card to see more details!</p>
            <div className='grid'>
                {
                    Object.keys(projectCodes).map((projectCode, index) => (
                        <div key={index} className='projects__projectCards__projectCard grid-item'>
                            {makeProjectCard(projectCodes[index])}
                        </div>
                    ))
                }
            </div>
        </section>
    )
}

export default Projects;